import React from 'react'
import { Link, useLocation } from "react-router-dom";

const Header = () => {
    const location = useLocation();
    return (
        <>
            {/* Spinner Start */}
            {/* <div
                id="spinner"
                className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            >
                <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                >
                    <span className="sr-only">Loading...</span>
                </div>
            </div> */}
            {/* Spinner End */}
            {/* Navbar & Hero Start */}
            <div className="container-fluid header position-relative  p-0">
                <nav className="navbar navbar-expand-lg fixed-top navbar-light px-4 px-lg-5 py-3 py-lg-0">
                    <Link to="/" className="navbar-brand p-0">
                        <h3 className="display-6 text-primary m-0">
                            <img
                                src="../logo.jpeg"
                                className="img-fluid"
                                alt="Logo"
                            /> CONSULTANTS
                        </h3>
                    </Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                    >
                        <span className="fa fa-bars" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <div className="navbar-nav ms-auto py-0">
                            <Link
                                to="/"
                                className={`nav-item nav-link${location.pathname === '/' ? ' active' : ''}`}
                            >
                                Home
                            </Link>
                            <Link
                                to="/about"
                                className={`nav-item nav-link${location.pathname === '/about' ? ' active' : ''}`}
                            >
                                About
                            </Link>
                            <Link
                                to="/service"
                                className={`nav-item nav-link${location.pathname.startsWith('/service') ? ' active' : ''}`}
                            >
                                Services
                            </Link>
                            <Link
                                to="/calculator"
                                className={`nav-item nav-link${location.pathname.startsWith('/service') ? ' active' : ''}`}
                            >
                                Area Calculator
                            </Link>
                            <Link
                                to="/travel"
                                className={`nav-item nav-link${location.pathname.startsWith('/travel') ? ' active' : ''}`}
                            >
                                Travels
                            </Link>
                            <Link
                                to="/ourGallery"
                                className={`nav-item nav-link${location.pathname.startsWith('/travel') ? ' active' : ''}`}
                            >
                                Our Gallery
                            </Link>
                            <Link
                                to="/contact"
                                className={`nav-item nav-link${location.pathname === '/contact' ? ' active' : ''}`}
                            >
                                Contact Us
                            </Link>
                        </div>
                        {/* <a href="#" class="btn btn-light border border-primary rounded-pill text-primary py-2 px-4 me-4">Contact Us</a> */}
                        {/* <a href="#" class="btn btn-primary rounded-pill text-white py-2 px-4">Sign Up</a> */}
                    </div>
                </nav>
            </div>
        </>

    )
}

export default Header